/**
 * defa.views.InvitationSubscriptionCollectionView
 * A view presenting a collection of an invitation's subscriptions.
 * @version 1.0.0
 */
import CollectionView             from 'scripts/poppet/collection-view';
import EmptyView                  from 'scripts/defa/basic/view-empty-view';
import InvitationSubscriptionView from 'scripts/defa/invitations/subscriptions/view-invitation-subscription-view';

const InvitationSubscriptionCollectionView = CollectionView.extend({
		
		// ------------------------------------------------
		// Setup
		// ------------------------------------------------
		
	childView : InvitationSubscriptionView,
	emptyView : EmptyView,
	emptyViewOptions: {
		context: 'no:invitations',
	},
	
	childViewOptions: function() {
		return {
			invitationId : this.options.invitation.get('id'),
			token: this.options.token,
		}
	},
		
		
		// ------------------------------------------------
		// Event Handlers
		// ------------------------------------------------
		
		
		
		// ------------------------------------------------
		// Other functions
		// ------------------------------------------------
		
});

export default InvitationSubscriptionCollectionView;
